import { createAction, props } from '@ngrx/store';
import { FavoriteLocation, FavoritePreference, FavoriteStop, FavoriteTicket } from '../favorites.model';
import { TravelMedia } from '@ridango/core/lib/ridango.models';
import { FavoriteSchedule } from '../favorites.model';

export const getFavoriteStops = createAction('[Favorites]: Get favorite stops');
export const getFavoriteStopsSuccess = createAction(
    '[Favorites]: Get favorite stops success',
    props<{ favoriteStops: FavoriteStop[] }>()
);

export const getFavoriteStopsFailed = createAction('[Favorites]: Get favorite stops failed ');

export const addFavoriteStop = createAction('[Favorites]: Add favorite stop', props<{ stop: FavoriteStop }>());
export const addFavoriteStopSuccess = createAction(
    '[Favorites]: Add favorite stop success',
    props<{ favoriteStop: FavoriteStop }>()
);

export const addFavoriteStopsFromLocalstorage = createAction(
    '[Favorites]: Add favorite stops from localstorage',
    props<{ favoriteStopIds: string[] }>()
);

export const addFavoriteStopsFromLocalstorageSuccess = createAction(
    '[Favorites]: Add favorite stops from localstorage success',
    props<{ favoriteStops: FavoriteStop[] }>()
);

export const updateFavoriteStop = createAction(
    '[Favorites]: Update favorite stop',
    props<{ stopId: string; alias: string }>()
);
export const updateFavoriteStopSuccess = createAction(
    '[Favorites]: Update favorite stop success',
    props<{ favoriteStop: FavoriteStop }>()
);

export const deleteFavoriteStop = createAction('[Favorites]: Delete favorite stop', props<{ stopId: string }>());
export const deleteFavoriteStopSuccess = createAction(
    '[Favorites]: Delete favorite stop success',
    props<{ stopId: string }>()
);

export const deleteFavoriteStops = createAction('[Favorites]: Delete favorite stops', props<{ stopIds: string[] }>());
export const deleteFavoriteStopsSuccess = createAction(
    '[Favorites]: Delete favorite stops success',
    props<{ stopIds: string[] }>()
);

export const getFavoriteLocations = createAction('[Favorites]: Get favorite locations');
export const getFavoriteLocationsSuccess = createAction(
    '[Favorites]: Get favorite locations success',
    props<{ favoriteLocations: FavoriteLocation[] }>()
);

export const addFavoriteLocation = createAction(
    '[Favorites]: Add favorite location',
    props<{
        latitude: number;
        longitude: number;
        name?: string;
        pointOfInterest?: boolean;
    }>()
);
export const addFavoriteLocationSuccess = createAction(
    '[Favorites]: Add favorite location success',
    props<{ favoriteLocation: FavoriteLocation }>()
);

export const addFavoriteLocationsFromLocalstorage = createAction(
    '[Favorites]: Add favorite locations from localstorage',
    props<{ favoriteLocations: FavoriteLocation[] }>()
);
export const addFavoriteLocationsFromLocalstorageSuccess = createAction(
    '[Favorites]: Add favorite locations from localstorage success',
    props<{ favoriteLocations: FavoriteLocation[] }>()
);

export const updateFavoriteLocation = createAction(
    '[Favorites]: Update favorite location',
    props<{
        id: string;
        latitude: number;
        longitude: number;
        name?: string;
    }>()
);
export const updateFavoriteLocationSuccess = createAction(
    '[Favorites]: Update favorite location success',
    props<{ favoriteLocation: FavoriteLocation }>()
);

export const deleteFavoriteLocation = createAction(
    '[Favorites]: Delete favorite location',
    props<{
        id?: string;
        latitude: number;
        longitude: number;
        name?: string;
    }>()
);
export const deleteFavoriteLocationSuccess = createAction(
    '[Favorites]: Delete favorite location success',
    props<{ favoriteLocation: FavoriteLocation }>()
);

export const deleteFavoriteLocations = createAction(
    '[Favorites]: Delete favorite locations',
    props<{ favoriteLocations: FavoriteLocation[] }>()
);
export const deleteFavoriteLocationsSuccess = createAction(
    '[Favorites]: Delete favorite locations success',
    props<{ favoriteLocations: FavoriteLocation[] }>()
);

export const getFavoriteTickets = createAction('[Favorites]: Get favorite tickets');
export const getFavoriteTicketsSuccess = createAction(
    '[Favorites]: Get favorite tickets success',
    props<{ favoriteTickets: FavoriteTicket[] }>()
);

export const getFavoriteTicketsFailed = createAction('[Favorites]: Get favorite tickets failed');

export const addFavoriteTicket = createAction(
    '[Favorites]: Add favorite ticket',
    props<{
        docNum: string;
        categoryCode: string;
        productId: number;
        startDateStr?: string;
        endDateStr?: string;
        includeReturnedTickets?: boolean;
        includeCancelledTickets?: boolean;
        channels?: string[];
    }>()
);

export const addFavoriteTicketSuccess = createAction(
    '[Favorites]: Add favorite ticket success',
    props<{ favoriteTicket: FavoriteTicket }>()
);
export const deleteFavoriteTicket = createAction(
    '[Favorites]: Delete favorite ticket',
    props<{ productId: number | string }>()
);
export const deleteFavoriteTicketSuccess = createAction(
    '[Favorites]: Delete favorite ticket success',
    props<{ productId: number | string }>()
);

export const getFavoritePreference = createAction('[Favorites]: Get favorite preference');
export const getFavoritePreferenceSuccess = createAction(
    '[Favorites]: Get favorite preference success',
    props<{ favoritePreference: FavoritePreference }>()
);
export const getFavoritePreferenceFailed = createAction('[Favorites]: Get favorite preference failed');

export const addFavoritePreference = createAction(
    '[Favorites]: Add favorite preference',
    props<{ preferenceType: TravelMedia; preferenceValue: string }>()
);
export const addFavoritePreferenceSuccess = createAction(
    '[Favorites]: Add favorite preference success',
    props<{ favoritePreference: FavoritePreference }>()
);

export const deleteFavoritePreference = createAction('[Favorites]: Delete favorite preference');
export const deleteFavoritePreferenceSuccess = createAction('[Favorites]: Delete favorite preference success');

export const getFavoriteSchedules = createAction('[Schedules favorite]: Get favorite schedules');
export const getFavoriteSchedulesSuccess = createAction(
    '[Schedules favorite]: Get favorite schedules success',
    props<{ favoriteSchedules: FavoriteSchedule[] }>()
);

export const addFavoriteSchedule = createAction(
    '[Schedules favorite]: Add favorite schedules',
    props<{ favoriteSchedule: FavoriteSchedule }>()
);
export const addFavoriteScheduleSuccess = createAction(
    '[Schedules favorite]: Add favorite schedules success',
    props<{ favoriteSchedule: FavoriteSchedule }>()
);

export const deleteFavoriteSchedules = createAction(
    '[Schedules favorite]: Delete favorite schedules',
    props<{ favoriteSchedules: FavoriteSchedule[] }>()
);

export const deleteFavoriteSchedulesSuccess = createAction(
    '[Schedules favorite]: Delete favorite schedules success',
    props<{ favoriteSchedules: FavoriteSchedule[] }>()
);

export const addFavoriteSchedulesFromLocalstorage = createAction(
    '[Favorites]: Add favorite schedules from localstorage'
);

export const addFavoriteSchedulesFromLocalstorageSuccess = createAction(
    '[Favorites]: Add favorite schedules from localstorage success',
    props<{ favoriteSchedules: FavoriteSchedule[] }>()
);
